module.exports = __webpack_public_path__ + "static/media/KCC_2025_Flyer.ed8ebd90.pdf";